import type { IAuthStepEnum } from "@/templates/authManagement/authStore";
import { generatePath } from "@routes/generatePath.ts";

export const path = {
  auth: {
    route: "/auth/:type",
    link: (type: IAuthStepEnum) => generatePath("/auth/:type", { type }),
  },
};
